enum ResellerTypes {
    NOT_A_RESELLER = 0,
    RESELLER = 1,
}

export default ResellerTypes;
